import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "next" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = { class: "answer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_DocumentChecked = _resolveComponent("DocumentChecked")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_form1 = _resolveComponent("form1")!
  const _component_form2 = _resolveComponent("form2")!
  const _component_form3 = _resolveComponent("form3")!
  const _component_form4 = _resolveComponent("form4")!
  const _component_form5 = _resolveComponent("form5")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString("标题：" + _ctx.form.levelTitle), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          size: "large",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back(-1))),
          style: {"background":"#f5f7fa","color":"#000"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeftBold)
              ]),
              _: 1
            }),
            _createTextVNode("   " + _toDisplayString(_ctx.$t("Detail.back")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "large",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitForm('ruleForm'))),
          style: {"background":"#4f4f4f","color":"#fff"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentChecked)
              ]),
              _: 1
            }),
            _createTextVNode("   " + _toDisplayString(_ctx.$t("Detail.save")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_segmented, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
      options: _ctx.options,
      block: "",
      size: "large",
      class: "selectBar"
    }, null, 8, ["modelValue", "options"]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_form1, {
        ref: "form1",
        dataForm: _ctx.form
      }, null, 8, ["dataForm"]), [
        [_vShow, _ctx.value == '故事脚本']
      ]),
      _withDirectives(_createVNode(_component_form2, {
        ref: "form2",
        dataForm: _ctx.form
      }, null, 8, ["dataForm"]), [
        [_vShow, _ctx.value == '关卡设计']
      ]),
      _withDirectives(_createVNode(_component_form3, {
        ref: "form3",
        dataForm: _ctx.form
      }, null, 8, ["dataForm"]), [
        [_vShow, _ctx.value == '提示']
      ]),
      _withDirectives(_createVNode(_component_form4, {
        ref: "form4",
        dataForm: _ctx.form
      }, null, 8, ["dataForm"]), [
        [_vShow, _ctx.value == '景点知识']
      ]),
      _withDirectives(_createVNode(_component_form5, {
        ref: "form5",
        dataForm: _ctx.form,
        dataForm2: _ctx.form2
      }, null, 8, ["dataForm", "dataForm2"]), [
        [_vShow, _ctx.value == '地点导航']
      ])
    ])
  ], 64))
}